import { Component, OnInit, OnDestroy, HostListener, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, NgForm } from '@angular/forms';
import { AuthenticationService } from '@servicios/authentication.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { ConfigService } from '@servicios/config.service';


export interface ILogin {
  user: string,
  password: string
}

@Component({
    selector: 'app-loginDialog',
    templateUrl: './loginDialog.component.html',
    styleUrls: ['./loginDialog.component.css'],
    standalone: false
})
export class LoginDialogComponent implements OnInit, OnDestroy {

  constructor(private fb: UntypedFormBuilder,
    private auth: AuthenticationService,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
    public configService: ConfigService
  ) { }

  @ViewChild('documentEditForm', { static: false }) documentEditForm: NgForm;
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.documentEditForm.ngSubmit.emit();
    }
  }

  public isLoading = false;
  form: UntypedFormGroup
  data: { user: string, _id: string, client?: boolean };

  ngOnInit() {
    this.data = this.config.data;
    
    this.form = this.fb.group({
      user: [{ value: this.data.user, disabled: true }, [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  closeDialog(value: boolean) {
    return this.dialogRef.close(value);
  }

  cerrarSesion() {
    // Llamar logout() desde el click del botón garantiza que estamos dentro
    // de Angular zone, por lo que router.navigate() funciona correctamente.
    this.auth.sesionExpirada = false;
    this.auth.logout();
    this.dialogRef.close(false);
  }

  userLogin(form: ILogin, client = false) {
    this.isLoading = true;
    const loginPromise = client
      ? this.auth.clientLogin(this.data.user, form.password, true)
      : this.auth.userLogin(this.data.user, form.password, true);

    loginPromise
      .then(() => {
        // Close the dialog AFTER the login Promise resolves —
        // never from inside a BehaviorSubject.next() callback, which
        // would cause synchronous re-entrancy and browser freeze.
        this.isLoading = false;
        this.closeDialog(true);
      })
      .catch(() => {
        // Error display is already handled by auth.handleLoginError via messageService.
        this.isLoading = false;
      });
  }

  ngOnDestroy() {
    // No subscriptions to clean up — login result is handled via Promise.
  }

}
